module.exports = __webpack_public_path__ + "static/header-logo-857582d967d77f6abdbf7e88f54865df.png";